/**
 * Helper function to wait for a condition to be true
 *
 * @param {Function} checkReadyCallback - The callback to check if the condition is true
 * @param {Function} callback           - The callback to execute when the condition is true
 * @param {number}   maxAttempts        - The maximum number of attempts to check
 * @param {number}   attemptDelay       - The delay between attempts
 * @return {void}
 */
const waitFor = ( checkReadyCallback, callback, maxAttempts = 5, attemptDelay = 50 ) => {
	let attempts = 0;

	const checkReady = () => {
		if ( checkReadyCallback() ) {
			callback();
		} else if ( attempts < maxAttempts ) {
			attempts++;
			setTimeout( checkReady, attemptDelay );
		}
	};

	checkReady();
};

export default waitFor;
